var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-button",
    {
      staticClass: "md-danger md-just-icon md-round",
      class: [_vm.canDelete ? "" : "button-disabled"],
      attrs: { title: "Delete order" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.handleDelete()
        },
      },
    },
    [
      _c(
        "md-icon",
        [
          _vm._v("\n        delete\n        "),
          !_vm.canDelete
            ? _c("md-tooltip", { attrs: { "md-direction": "left" } }, [
                _vm._v(
                  "\n            Orders with " +
                    _vm._s(_vm.status) +
                    " status cannot be deleted.\n        "
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }